import { menu } from './menu';
import { router } from './router';

export const Zakaznicke = {
	menu,
	router,
};
